/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018-2022. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
var Paths = {
  HOME: '/',
  ACCOUNT: '/account',
  APPLICATION_OVERVIEW: '/application-overview',
  APPLY: '/apply',
  BENEFIT_SELECTION: '/benefit-selection',
  BENEFITS: '/benefits',
  // CHANGE_PASSWORD: '/change-password',
  CONTACT_US: '/contact-us',
  FAQS: '/faqs',
  FORGOT_PASSWORD: '/forgot-password',
  PASSWORD_CHANGED: '/password_changed',
  LOGIN: '/login',
  PAYMENTS: {
    ROOT: '/payments',
    DETAILS: '/payments/details',
    NEXT_DETAILS: '/payments/next_details'
  },
  PROFILE: '/profile',
  SIGNUP: '/signup',
  ELIGIBILITY: {
    ROOT: '/eligibility',
    BENEFIT_SELECTION: '/eligibility/benefit-selection',
    FORM: '/eligibility/form/new',
    RESUME: '/eligibility/form',
    FILTER_FORM: '/eligibility/filter-form/new',
    FILTER_FORM_RESUME: '/eligibility/filter-form'
  },
  LIFE_EVENTS: {
    ROOT: '/life-events',
    FORM: '/life-events/form/new',
    RESUME: '/life-events/form',
    HISTORY: '/life-events/history',
    OVERVIEW: '/life-events/overview'
  },
  APPEALS: {
    ROOT: '/appeals',
    FORM: '/appeals/form/new',
    RESUME: '/appeals/form',
    OVERVIEW: '/appeals/overview',
    SUBMITTED: '/appeals/submitted'
  },
  NOTICES: {
    ROOT: '/notices',
    DETAILS: '/notices/details'
  },
  VERIFICATIONS: {
    ROOT: '/verifications',
    DETAILS: '/verifications/details'
  },
  IEGVERIFICATIONS: {
    ROOT: '/ieg/verifications',
    DETAILS: '/ieg/verifications/details'
  }
};

/**
 * Provides access the the URLs that are mapped to each page via the route configuration in the
 * universal access library.
 */
export default Paths;